import { Box } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import { Layout } from '@roc/feature-app-core';
import { Tabs } from '@roc/ui';
import { observer } from 'mobx-react';
import { InternalValuationTab } from './types/internalValuationTypes';
import { useInternalValuationStore } from './hooks/useInternalValuationStore';
import { InternalValuationLoansGrid } from './components/internalValuationDashboard';
import { internalReviewLoansColumns, taskColumns, rentalRiskReviewColumns, disputeAppraisalColumns } from './utils/dashboardColumns';
import { SubStatusTable } from './components/subStatusTableCounts';

const TABS = [
  {
    value: InternalValuationTab.ALL_LOANS,
    label: 'All Loans',
  },
  {
    value: InternalValuationTab.DISPUTE_SECOND_APPRAISAL,
    label: 'Dispute Second Appraisal',
  },
  {
    value: InternalValuationTab.RENTAL_RISK_PROFILER_REVIEW,
    label: 'Rental RiskProfiler Review',
  },
  {
    value: InternalValuationTab.DISPUTE_APPRAISAL,
    label: 'Disputes',
  },
];

const useStyles = makeStyles((theme: Theme) => ({
  container: {
  },
}));

export const InternalValuation = observer(() => {
  const classes = useStyles();
  const { internalValuationStore } = useInternalValuationStore();
  const { tab } = internalValuationStore;

  return (
    <Layout title="Internal Valuation Loans" containerClass={classes.container}>
      <Box pb={2}>
        <Tabs
          selectedTab={TABS.findIndex(t => t.value === tab)}
          tabs={Object.values(TABS)}
          onTabChange={(e, i) => internalValuationStore.setTab(TABS[i].value)}
        />
      </Box>
      {tab !== InternalValuationTab.DISPUTE_SECOND_APPRAISAL && tab !== InternalValuationTab.DISPUTE_APPRAISAL && <Box>
        <SubStatusTable
          counts={internalValuationStore.getInternalValuationLoanCountsBySubStatus()}
        />
      </Box>}
      {tab === InternalValuationTab.ALL_LOANS && (
        <InternalValuationLoansGrid columns={internalReviewLoansColumns} />
      )}
      {tab === InternalValuationTab.DISPUTE_SECOND_APPRAISAL && (
        <InternalValuationLoansGrid columns={taskColumns} />
      )}
      {tab === InternalValuationTab.RENTAL_RISK_PROFILER_REVIEW && (
        <InternalValuationLoansGrid columns={rentalRiskReviewColumns} />
      )}
      {tab === InternalValuationTab.DISPUTE_APPRAISAL && (
        <InternalValuationLoansGrid columns={disputeAppraisalColumns} />
      )}
    </Layout>
  );
});
